export const supportLink = {
    inquiryText:
        'If the problem is not resolved or if you have any questions or requests regarding the functionalities, please contact us below.',
    inquiry: 'Inquiry',
    otherPages: 'These pages below could also be of your use:'
}
